import { useState } from 'react';

import { GetSignupBrandingResponse } from '@iwoca/lapi-client/edge';
import { ContentSwitcher } from '@iwoca/orion';

import styles from './Admin.module.css';
import { useGetLogoUrls } from './adminQueries';
import LogoHeadingContent from '../components/LogoHeading/LogoHeadingContent';
import { useGetProfile } from '../lendingApi/lendingApiQueries';
import { getRuntimeEnvironment } from '../utils/getRuntimeEnvironment';

const Admin = () => {
  const { profile } = useGetProfile();

  const user_type = profile?.user_type;

  const [brandingType, setBrandingType] =
    useState<GetSignupBrandingResponse['signup_branding_type']>('iwoca');

  const { logosData, isLoading } = useGetLogoUrls(user_type);

  if (user_type && user_type !== 'staff') {
    window.location.href = '/404';
  }

  if (!user_type || isLoading || !logosData) return <div>Loading</div>;

  const runtimeEnvironment = getRuntimeEnvironment();
  // Hard code environment to production if you need to test prod logos locally
  const baseLogoUrl =
    runtimeEnvironment === 'production'
      ? 'https://user-content.iwoca.com/'
      : 'https://user-content.iwoca-dev.com/';

  return (
    <div className={styles.container}>
      <h1>View logos with different branding types</h1>
      <div className={styles.contentContainer}>
        <ContentSwitcher
          value={brandingType}
          wrapperClassName={styles.contentSwitcher}
        >
          <ContentSwitcher.Button
            id="iwoca"
            setSelected={() => setBrandingType('iwoca')}
          >
            iwoca
          </ContentSwitcher.Button>
          <ContentSwitcher.Button
            id="combined"
            setSelected={() => setBrandingType('combined')}
          >
            combined
          </ContentSwitcher.Button>
          <ContentSwitcher.Button
            id="partner"
            setSelected={() => setBrandingType('partner')}
          >
            partner
          </ContentSwitcher.Button>
        </ContentSwitcher>
        {logosData.data.map((logo) => (
          <div key={logo.affiliate_tag} className={styles.logoContainer}>
            <LogoHeadingContent
              logo={`${baseLogoUrl}${logo.logo_file_name}`}
              partner_name={logo.affiliate_tag}
              signup_branding_type={brandingType}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Admin;
